'use client'
import { FC } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import s from './typeform.module.css';

/**
 * Props for `Typeform`.
 */
export type TypeformProps = SliceComponentProps<Content.TypeformSlice>;

/**
 * Component for "Typeform" Slices.
 */
const Typeform: FC<TypeformProps> = ({ slice }) => {
    if(!slice.primary.typeform_live_embed_id) {
        return null;
    }
    return (
        <section
            data-slice-type={slice.slice_type}
            data-slice-variation={slice.variation}
        >
            <div data-tf-live={slice.primary.typeform_live_embed_id} className={s.frameRoot}>
            </div>
            <script src="//embed.typeform.com/next/embed.js"></script>
        </section>
    );
};

export default Typeform;
